import {types} from 'mobx-state-tree';
import {ListingProvider, ReservationState} from '../enums';
import GuestModel from '../GuestModel';
import ListingModel from '../ListingModel';

const ReservationModel = types
  .model('Reservation', {
    id: types.identifierNumber,
    confirmationCode: types.string,
    checkInDate: types.string,
    checkOutDate: types.string,
    createdAt: types.number,
    currency: types.maybe(types.string),
    earning: types.maybe(types.number),
    source: ListingProvider,
    guest: GuestModel,
    listing: ListingModel,
    state: ReservationState,
    channel: types.maybe(types.model({id: types.identifierNumber}))
  })
  .views(self => ({
    get channelId() {
      return self.channel ? self.channel.id : null;
    }
  }));

export type ReservationModelType = typeof ReservationModel.Type;

export default ReservationModel;



// WEBPACK FOOTER //
// ./src/models/ReservationModel/ReservationModel.ts